import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { Options } from "./EditHome/Options";
import { WelcomeBanner } from "./EditHome/WelcomeBanner";

export const CustomizeHomeSectionSelector = ({
  metaData,
  initialFormValues,
  setIsPristine,
}) => {
  const { currentSection } = useCustomizeUIData();

  if (currentSection === t("home_page.banners")) {
    return (
      <WelcomeBanner
        initialFormValues={initialFormValues}
        setIsPristine={setIsPristine}
      />
    );
  }

  if (currentSection === t("home_page.options")) {
    return (
      <Options
        metaData={metaData}
        initialFormValues={initialFormValues}
        setIsPristine={setIsPristine}
      />
    );
  }

  return null;
};

CustomizeHomeSectionSelector.propTypes = {
  metaData: PropTypes.object,
  initialFormValues: PropTypes.object,
  setIsPristine: PropTypes.func,
};
